// extracted by mini-css-extract-plugin
export default {"container":"Navigation_container__oqhZU","iconContainer":"Navigation_iconContainer__-7IqT","iconIndicator":"Navigation_iconIndicator__I940z"};